import React from 'react';

interface ProgressBarProps {
  aiIconPosition?: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ aiIconPosition = 40 }) => {
  const getDotColor = (index: number): string => {
    const baseColor = '#7461EE';
    const lightenFactor = Math.abs(6 - index) * 0.1;
    return lightenColor(baseColor, lightenFactor);
  };

  const lightenColor = (color: string, factor: number): string => {
    const num = parseInt(color.slice(1), 16);
    const amt = Math.round(2.55 * factor * 100);
    const R = (num >> 16) + amt;
    const G = ((num >> 8) & 0x00ff) + amt;
    const B = (num & 0x0000ff) + amt;
    return `#${(
      0x1000000 +
      (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)
    )
      .toString(16)
      .slice(1)}`;
  };

  return (
    <div className="flex justify-between items-center w-full px-6 py-2 rounded-3xl">
      {Array.from({ length: 10 }, (_, index) => (
        <div
          key={index}
          className="w-1.5 h-1.5 rounded-full transition-colors duration-300"
          style={{
            backgroundColor: getDotColor(index + 1),
          }}
        />
      ))}
    </div>
  );
};

export default ProgressBar;